export const Rebate = {
    NotSelect: '— 不选 —',
    KeepUnchanged: '不更新',
    KeepUnchangedStrategyTip: '该子类型的开户权限保持不变，此处仅配置返佣策略；留空则维持其现有返佣策略。',
    AccountPermission: '开户权限',
    UpdateLink: '更新链接',
    AddLink: '新增链接',
    AccountPermissionDesc: '为当前链接配置 MT4 / MT5 账户等级组合。',
    ClientGroupConfig: '客户组别配置',
    ClientGroup: '客户组别',
    SelectLink: '选择链接',
    SelectLinkDesc: '返佣策略根据全部已保存链接的子类型去重集合自动生成。',
    NoLink: '暂无链接，请在上方「开户权限」新增',
    LinkNew: '新增链接',
    LinkExisting: '现有链接',
    DefaultLink: '默认链接',
    SubType: '子类型',
    FxValue: '外汇数值',
    MetalValue: '贵金属数值',
    StrategyEmpty: '请在上方「选择链接」中新增或保留相关子类型',
    RebateStrategyTitle: '返佣策略',
    TopIbStrategyReadonlyTip: '客户升级顶级IB时，不允许变更返佣策略',
    IsTopIbStrategyReadonlyTip: '客户为顶级IB时，不允许变更返佣策略',
    UnitNote: '* 所有数值单位以实际协议为准',
    HintSelectAtLeastOne: '请至少选择一项开户权限',
    HintDuplicateLink: '已存在相同配置的链接',
    HintLinkAdded: '已新增链接',
    HintLinkUpdated: '链接已更新',
    TopTier: '顶级组别',
    UpgradeTopIbTitle: '客户升级顶级IB',
    UpgradeToTopAgent: '是否升级为顶级代理',
    SelectTopGroup: '选择顶级组',
    NoSuperiorAgentTip: '无上级代理，请先绑定后再重试',
    UpgradeSubIbTitle: '客户升级下级IB',
    UpdateRebateConfigTitle: 'IB更新返佣配置',
    IbConfigAuditApprove: '审核通过：{auditComment}',
    IbConfigAuditReject: '拒绝原因：{auditComment}',
    KycNotPassedTip: '客户 KYC 尚未全部通过',
    HasPendingTip: '该客户已有未完结工单，请等待处理完成',
    CheckPendingTip: '正在校验工单状态...',
    AlreadyIbTip: '该账户的通行证已关联IB产品,不可重复开通IB',
    RebateExceedTitle: '返佣值校验未通过',
    RebateExceedDesc: '以下返佣值超过上级代理对应上限，请调整后重新提交：',
    PreviewStrategyTitle: '返佣策略预览',
    Symbol: '品种组',
    BasicMoney: '基础返佣',
    AddCommMoney: '加佣返佣',
    AddPointPoint: '加点返佣',
    ColMoney: '金额',
    ColPercentage: '百分比',
    ColPoint: '点',
    HintFillAllValues: '请填写所有返佣值',
    HintDefaultLinkRequired: '默认链接未勾选',
    HintMixedLinkNeedsUpdate: '以下链接同时包含不同类别的子类型，请先选中该链接并点击「更新链接」后再提交：',
    RebateSettingConflictTip: '返佣设置的金额小于下级或大于上级。 详细信息如下:',
    ColAction: '操作',
    DeleteStrategyConfirm: '确认删除该子类型的返佣策略？',
    DeleteLockedTip: '该组别已绑定客户，不可删除',
    DeleteLockedByMoveTip: '已有客户移入该链接，不可删除',
    FilterByLink: '客户组别名称',
    FilterPlaceholder: '输入关键词搜索客户组别名称...',
    FilterHint:
        '已选 {selected} / {total} 条链接：下方返佣策略仅展示所选链接的子类型（已去重），提交时将包含全部链接数据',
    ExistingLink: '现有',
    SelectAll: '全选',
    // ── 选择链接 - 设置（账户列表 / 账户权限 / 客户移动，meegle 14436933）──
    LinkSetting: '设置',
    LinkSettingTitle: '设置 - {name}',
    LinkSettingNewTip: '新建链接尚未创建，暂无账户数据',
    AccountListTab: '账户列表',
    AccountPermissionTab: '账户权限',
    PermissionHistoryTip: '当前查询结果为历史数据，不包含此次工单改动',
    AccountSearchPlaceholder: '按账户 ID / 姓名搜索',
    JoinTime: '加入时间',
    AllServers: '全部服务器',
    AllBasicTypes: '全部基础账户类型',
    BatchMove: '批量移动',
    MoveTitle: '移动账户',
    MoveTarget: '目标链接',
    MoveCountTip: '本次移动 {count} 个账户：',
    MoveSuccess: '移动成功',
    MoveConfirmTitle: '移动确认',
    MoveConfirmDesc: '确认将以下 {count} 个账户移动到新的客户组别？',
    MoveFromGroup: '原组别：',
    MoveToGroup: '目标组别：',
    MoveConfirmWarning: '移动后账户的开户权限与返佣策略将按目标客户组别生效，请确认无误。',
    MoveConfirmBack: '返回修改',
    MoveConfirmOk: '确认移动',
    MoveEffectTip: '移动操作将在工单提交并审批通过后生效',
    MoveCancelledOnDelete: '删除链接已取消 {count} 条待移动',
    HintNoMoveTarget: '没有可移动到的其它链接',
    HintSelectMoveTarget: '请选择目标链接',
    HintMoveTargetEmpty: '移动目标链接未配置任何子类型，无法创建，请先配置或更换目标',
    HintMoveTargetDuplicateName: '移动目标链接名称重复，请先改名再提交',
    // ── IB返佣策略页（需求 7 销售端查看IB返佣策略详情）──
    IbStrategyTitle: 'IB返佣策略',
    Platform: 'MT平台',
    BasicAccountType: '基础账号类型',
    SymbolGroup: '品种组',
    AllSymbolGroups: '所有品种组',
    AccountIdPlaceholder: '请输入账户ID查询',
    StrategyAccountPermission: '账户权限',
    BasicRebate: '基础返佣',
    CommissionRebate: '加佣返佣',
    PointRebate: '加点返佣',
    // ── 我的介绍经纪人交易量统计优化 ──
    TitleAggregatedTradeVolume: '合计交易量',
    AggregatedTradeVolumeTip: '下方列表交易量合计',
    OneClickSync: '同步',
    OneClickClear: '一键清空',
    ClearConfirm: '确认清空所有返佣策略输入值？',
    SyncNothing: '请先在该计算规则中填写返佣值，且其他计算规则存在对应子类型',
    SyncRounded: '部分同步值超出该列小数位，已四舍五入',
};
